import {gql} from "@apollo/client"

export const UPDATE_PRODUCT_PHOTO_SORT = gql`
  mutation UpdateProductPhotoSortList($tagId: Int!, $data: [JSON]) {
    UpdateProductPhotoSortList(tagId: $tagId, data: $data)
  }
`
